import { FC } from 'react'
import { FilterSection } from '@/network/graphql.g'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  sizes: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterSizesSlidePage: FC<Props> = ({
  sizes,
  initialSelections,
  updatePendingFilter
}) => {
  const items: MobileFilterItemType[] = sizes.flatMap((s) =>
    s.items.map((i) => ({
      id: i.id,
      title: i.value,
      count: i.count
    }))
  )

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
    />
  )
}
export default FilterSizesSlidePage
